module.exports = __webpack_public_path__ + "static/AL.190207.COH.WEBW.HSBCLogoResized-3ff7ab30dd166c2c266e6c0b75867aaf.png";